import { Controller } from 'stimulus';
import Swiper from 'swiper';

class SwiperController extends Controller {
  connect() {
    this.swiper = new Swiper(this.element, {
      slidesPerView: 'auto',
      spaceBetween: 15,
      freeMode: true,
      breakpoints: {
        992: {
          spaceBetween: 30,
        },
      },
    });

    if (this.swiper.initialized) {
      this.calculateHeight();
    }

    this.swiper.on('init resize update', () => {
      this.calculateHeight();
    });
  }

  calculateHeight() {
    const height = this.swiper.slides.reduce((accumulator, slide) => {
      if (slide.firstElementChild.offsetHeight > accumulator) {
        return slide.firstElementChild.offsetHeight;
      }

      return accumulator;
    }, 0);

    this.element.style.height = `${height}px`;
  }
}

export default SwiperController;
